import React, { useMemo } from 'react';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Button } from '@saviynt/design-system';
import getTooltip from '../shared/MigrationToolTip';
import useStyles from './styles/ObjectTypeCard.styles';
import { UI_LABELS } from '../../constants/stringConstants';

const parseTooltipHtml = (html) => {
  if (!html) return null;
  const parts = html.split(/(<b>|<\/b>|<br\s*\/?>)/gi);
  let bold = false;
  return parts.map((part, i) => {
    const lower = part.toLowerCase();
    if (lower === '<b>') { bold = true; return null; }
    if (lower === '</b>') { bold = false; return null; }
    if (/^<br\s*\/?>$/i.test(part)) return <br key={i} />;
    if (!part) return null;
    // eslint-disable-next-line react/no-array-index-key
    return bold ? <b key={i}>{part}</b> : <span key={i}>{part}</span>;
  });
};

function ObjectTypeCard({ activeTab, objType, count, onSelect, isExpanded, onToggleExpand, sourceType }) {
  const classes = useStyles();
  const tooltip = getTooltip(objType.type, sourceType);
  const parsedTooltip = useMemo(() => parseTooltipHtml(tooltip), [tooltip]);

  return (
    <div className={`${classes.card} ${isExpanded ? classes.cardExpanded : ''}`}>
      <div className={classes.header}>
        <div className={classes.iconWrapper}>{objType.icon}</div>
        <Typography variant="h6" className={classes.title}>
          {objType.label}
        </Typography>
        <div className={classes.countBadge}>
          <Typography className={classes.count}>{count}</Typography>
        </div>
      </div>

      <Typography
        variant="body2"
        className={`${classes.description} ${!isExpanded ? classes.descriptionCollapsed : ''}`}
      >
        {parsedTooltip}
      </Typography>

      <div className={classes.footer}>
        {tooltip.length > 140 ? (
          <button type="button" onClick={onToggleExpand} className={classes.toggleButton}>
            {isExpanded ? UI_LABELS.SHOW_LESS : UI_LABELS.SHOW_MORE}
            <span className={`${classes.chevron} ${isExpanded ? classes.chevronOpen : ''}`}>▼</span>
          </button>
        ) : (
          <div />
        )}
        <Button kind="outlined" size="small" className={classes.actionButton} onClick={onSelect}>
          {activeTab === 0 ? UI_LABELS.MIGRATE : UI_LABELS.VIEW} {count}{' '}
          {count !== 1 ? UI_LABELS.OBJECTS : UI_LABELS.OBJECT}
        </Button>
      </div>
    </div>
  );
}

ObjectTypeCard.propTypes = {
  activeTab: PropTypes.number,
  objType: PropTypes.shape({
    type: PropTypes.string,
    icon: PropTypes.node,
    label: PropTypes.string,
  }),
  count: PropTypes.number,
  onSelect: PropTypes.func,
  isExpanded: PropTypes.bool,
  onToggleExpand: PropTypes.func,
  sourceType: PropTypes.string,
};

ObjectTypeCard.defaultProps = {
  activeTab: 0,
  objType: {},
  count: 0,
  onSelect: undefined,
  isExpanded: false,
  onToggleExpand: undefined,
  sourceType: null,
};

export default ObjectTypeCard;
